module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Regular.d7d5d45.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Regular.ttf
// module id = +LmY
// module chunks = 1